export default __webpack_public_path__ + "static/media/vector-8.a3048ee9.png";